import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { getRequest, postRequest } from 'utils/http'

export const useGetCancellations = (page = 1, perPage = 20, status = '', search = '') => {
  return useQuery({
    queryKey: ['cancellation-requests', page, perPage, status, search],
    queryFn: async () => {
      const response = await getRequest('cancellation-requests', {
        params: {
          page,
          per_page: perPage,
          status: status || undefined,
          search: search || undefined,
        },
      })
      return response
    },
    keepPreviousData: true,
  })
}

export const useGetCancellationDetails = (id) => {
  return useQuery({
    queryKey: ['cancellation-request', id],
    queryFn: async () => {
      const response = await getRequest(`cancellation-requests/${id}`)
      return response
    },
    enabled: !!id,
  })
}

export const useApproveCancellation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({ id, adminNotes }) => {
      return await postRequest(`cancellation-requests/${id}/approve`, {
        admin_notes: adminNotes,
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['cancellation-requests'] })
      queryClient.invalidateQueries({ queryKey: ['tickets'] })
      queryClient.invalidateQueries({ queryKey: ['reports_analytics'] })
      queryClient.invalidateQueries({ queryKey: ['event_report'] })
    },
  })
}

export const useRejectCancellation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({ id, adminNotes }) => {
      return await postRequest(`cancellation-requests/${id}/reject`, {
        admin_notes: adminNotes,
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['cancellation-requests'] })
    },
  })
}
